import { render, staticRenderFns } from "./sa-report.vue?vue&type=template&id=f3fcb9fa&"
import script from "./sa-report.vue?vue&type=script&lang=js&"
export * from "./sa-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports